let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dCtYK")).then(() => parcelRequire('fKrl6'));